var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: _vm.getTitle,
        "no-close-on-backdrop": "",
        centered: "",
        "hide-footer": "",
        size: "xl"
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "div",
        { staticClass: "row scroll" },
        [
          _c("div", { staticClass: "col-12" }, [
            _c("h5", { staticClass: "text-primary" }, [
              _vm._v(
                " Este expediente ha sido creado por " +
                  _vm._s(_vm.file.solicitanteNombre) +
                  " "
              ),
              _c("small", [_vm._v(_vm._s(_vm.file.solicitanteEmail))]),
              _vm.file.solicitanteGrupoNombre
                ? _c("span", [
                    _vm._v(
                      " , perteneciente a la unidad " +
                        _vm._s(_vm.file.solicitanteGrupoNombre) +
                        " "
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _c(
            "div",
            { staticClass: "col-12", staticStyle: { margin: "0 auto" } },
            [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c(
                    "div",
                    { staticClass: "shadow col-4" },
                    [
                      _c(
                        "vs-list",
                        [
                          _vm.isConvention
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "tag",
                                  title: _vm.file.numero || "-",
                                  subtitle: "Número de documento"
                                }
                              })
                            : _vm._e(),
                          _c("vs-list-item", {
                            attrs: {
                              icon: "description",
                              title: _vm.file.emisorCentroCostoNombre || "-",
                              subtitle: "Tipo de documento"
                            }
                          }),
                          _vm.file.emisorSucursalDireccion &&
                          (!_vm.isUseExternalForm ||
                            _vm.file.claseMercadoPublico === "numOf")
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "description",
                                  title:
                                    _vm.file.emisorSucursalDireccion || "-",
                                  subtitle: "Documento"
                                }
                              })
                            : _vm._e(),
                          _vm.file.numeroInt
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "tag",
                                  title: _vm.file.numeroInt || "-",
                                  subtitle: "Nº Documento"
                                }
                              })
                            : _vm._e(),
                          _vm.file.fechaEmision &&
                          (_vm.file.claseMercadoPublico === "int" ||
                            _vm.file.claseMercadoPublico === "ext")
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "date_range",
                                  title: _vm._f("dateFormat")(
                                    _vm.file.fechaEmision
                                  ),
                                  subtitle: "Fecha Documento"
                                }
                              })
                            : _vm._e(),
                          (_vm.file.claseMercadoPublico === "numInt" ||
                            _vm.file.claseMercadoPublico === "numOf") &&
                          _vm.file.condicionDespacho === "0" &&
                          (!_vm.isUseExternalForm ||
                            _vm.file.claseMercadoPublico === "numOf")
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "description",
                                  title: "Papel" || "-",
                                  subtitle: "Formato"
                                }
                              })
                            : _vm._e(),
                          (_vm.file.claseMercadoPublico === "numInt" ||
                            _vm.file.claseMercadoPublico === "numOf") &&
                          _vm.file.condicionDespacho === "1" &&
                          (!_vm.isUseExternalForm ||
                            _vm.file.claseMercadoPublico === "numOf")
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "description",
                                  title: "Electrónico" || "-",
                                  subtitle: "Formato"
                                }
                              })
                            : _vm._e(),
                          _vm.file.claseMercadoPublico === "ext"
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "description",
                                  title: "Externo",
                                  subtitle: "Tipo Expediente"
                                }
                              })
                            : _vm._e(),
                          _vm.file.claseMercadoPublico === "int"
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "description",
                                  title: "Interno",
                                  subtitle: "Tipo Expediente"
                                }
                              })
                            : _vm._e(),
                          _vm.file.transportePuertoTipo === "0"
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "description",
                                  title: "No",
                                  subtitle: "Es privado"
                                }
                              })
                            : _vm._e(),
                          _vm.file.transportePuertoTipo === "1"
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "description",
                                  title: "Si",
                                  subtitle: "Es privado"
                                }
                              })
                            : _vm._e(),
                          _vm.file.transportePuertoTipo === "2"
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "description",
                                  title: "Si",
                                  subtitle: "Es Reservado"
                                }
                              })
                            : _vm._e(),
                          _vm.isAguasAndinas && _vm.getMetadataValue("DOCNUM")
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "description",
                                  title: _vm.getMetadataValue("DOCNUM"),
                                  subtitle: "Número interno Librería"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "shadow col-4" },
                    [
                      _c(
                        "vs-list",
                        [
                          _vm.isAguasAndinas && _vm.getMetadataValue("ID_TEMA")
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "description",
                                  title: _vm.getMetadataValue("ID_TEMA"),
                                  subtitle: "Tema"
                                }
                              })
                            : _vm._e(),
                          _vm.isAguasAndinas &&
                          _vm.getMetadataValue("ID_SUBTEMA")
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "description",
                                  title: _vm.getMetadataValue("ID_SUBTEMA"),
                                  subtitle: "Subtema"
                                }
                              })
                            : _vm._e(),
                          _vm.file.compradorArea && !_vm.haveSISSConfig
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "account_balance",
                                  title: _vm.file.compradorArea || "-",
                                  subtitle: "Tipo institución remitente"
                                }
                              })
                            : _vm._e(),
                          _vm.file.compradorCodigo &&
                          _vm.isUseExternalForm &&
                          _vm.haveSISSConfig
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "account_balance",
                                  title: _vm.file.compradorCodigo || "-",
                                  subtitle: "Remitente"
                                }
                              })
                            : _vm._e(),
                          _vm.file.emisorContactoArea &&
                          (_vm.file.compradorArea === "PJU" ||
                            _vm.file.compradorArea === "OES" ||
                            _vm.file.compradorArea === "PROV" ||
                            _vm.file.compradorArea === "SAN")
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "account_balance",
                                  title: _vm.file.emisorContactoArea || "-",
                                  subtitle: "Institución remitente"
                                }
                              })
                            : _vm._e(),
                          _c("vs-list-item", {
                            attrs: {
                              icon: "account_circle",
                              title: _vm.file.emisorContactoNombre || "-",
                              subtitle: "Persona remitente"
                            }
                          }),
                          !_vm.isUseExternalForm &&
                          _vm.file.claseMercadoPublico !== "ext"
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "assignment_ind",
                                  title: _vm.file.emisorContactoCargo || "-",
                                  subtitle: "Cargo persona remitente"
                                }
                              })
                            : _vm._e(),
                          _vm.file.emisorContactoEmail
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "mail",
                                  title: _vm.file.emisorContactoEmail || "-",
                                  subtitle: "Correo persona remitente"
                                }
                              })
                            : _vm._e(),
                          _vm.file.emisorContactoTelefono
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "assignment_ind",
                                  title: _vm.file.emisorContactoTelefono || "-",
                                  subtitle: "Teléfono persona remitente"
                                }
                              })
                            : _vm._e(),
                          _vm.file.plazo > 0
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "thumb_up",
                                  title: _vm.file.plazo || "-",
                                  subtitle: "Adhesión"
                                }
                              })
                            : _vm._e(),
                          _vm.file.transporteNotas &&
                          (!_vm.isUseExternalForm ||
                            _vm.file.claseMercadoPublico === "numOf")
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "subject",
                                  title: _vm.file.transporteNotas || "-",
                                  subtitle: "Detalle"
                                }
                              })
                            : _vm._e(),
                          _vm.file.transporteNotas && _vm.isUseExternalForm
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "room",
                                  title: _vm.file.transporteNotas || "-",
                                  subtitle: "Oficina de partes destino"
                                }
                              })
                            : _vm._e(),
                          _vm.file.transporteViaTransporteCodigoTransporte &&
                          _vm.isUseExternalForm
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "subject",
                                  title:
                                    _vm.file
                                      .transporteViaTransporteCodigoTransporte ||
                                    "-",
                                  subtitle: "Link carpeta compartida"
                                }
                              })
                            : _vm._e(),
                          _vm.file.compradorTelefono && _vm.isUseExternalForm
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "subject",
                                  title: _vm.file.compradorTelefono || "-",
                                  subtitle: "Número SAC"
                                }
                              })
                            : _vm._e(),
                          _vm.file.compradorEmail && _vm.isUseExternalForm
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "subject",
                                  title: _vm.file.compradorEmail || "-",
                                  subtitle: "Número oficio"
                                }
                              })
                            : _vm._e(),
                          _vm.file.compradorCargo && _vm.isUseExternalForm
                            ? _c("vs-list-item", {
                                attrs: {
                                  icon: "subject",
                                  title: _vm.file.compradorCargo || "-",
                                  subtitle: "Id Adquisiciones"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.authors ? _c("ConventionAuthors") : _vm._e(),
                  _vm.participants ? _c("ConventionParticipants") : _vm._e(),
                  _vm.isConvention
                    ? _c(
                        "div",
                        { staticClass: "col-md-4 shadow" },
                        [
                          _c(
                            "vs-list",
                            [
                              _vm.detailsFile.dnt && _vm.detailsFile.dnt.titulo
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "subject",
                                      title: _vm.detailsFile.dnt.titulo,
                                      subtitle: "Nombre del expediente"
                                    }
                                  })
                                : _vm._e(),
                              _vm.detailsFile.dnt &&
                              _vm.detailsFile.dnt
                                .transporteViaTransporteVehiculoPatente
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "subject",
                                      title: _vm.getProposalStatus,
                                      subtitle: "Estado de la propuesta"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isConvention
                    ? _c(
                        "div",
                        { staticClass: "col-md-4 shadow" },
                        [
                          _c(
                            "vs-list",
                            [
                              _vm.file
                                .transporteViaTransporteCodigoTransporte ===
                                "1" &&
                              (!_vm.isUseExternalForm ||
                                _vm.file.claseMercadoPublico === "numOf")
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "description",
                                      title: "Si",
                                      subtitle: "Acompaña físico"
                                    }
                                  })
                                : _vm._e(),
                              _vm.file
                                .transporteViaTransporteCodigoTransporte ===
                                "0" &&
                              (!_vm.isUseExternalForm ||
                                _vm.file.claseMercadoPublico === "numOf")
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "description",
                                      title: "No",
                                      subtitle: "Acompaña físico"
                                    }
                                  })
                                : _vm._e(),
                              _vm.file.transportePuertoCodigo &&
                              _vm.isUseExternalForm &&
                              _vm.haveSISSConfig
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "description",
                                      title: _vm.file.transportePuertoCodigo,
                                      subtitle: "Código Rif"
                                    }
                                  })
                                : _vm._e(),
                              _vm.file.emisorContactoCodigo &&
                              _vm.isUseExternalForm &&
                              _vm.isFormInt
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "description",
                                      title: _vm.file.emisorContactoCodigo,
                                      subtitle: "Código documento"
                                    }
                                  })
                                : _vm._e(),
                              (_vm.file.claseMercadoPublico === "numInt" ||
                                _vm.file.claseMercadoPublico === "numOf") &&
                              _vm.file.condicionDespacho === "1" &&
                              _vm.isUseExternalForm
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "description",
                                      title: _vm.file.condicionDespacho || "-",
                                      subtitle: "Nº expediente"
                                    }
                                  })
                                : _vm._e(),
                              _vm.file.transportePuertoNombre &&
                              _vm.isUseExternalForm
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "description",
                                      title:
                                        _vm.file.transportePuertoNombre || "-",
                                      subtitle: "Proceso"
                                    }
                                  })
                                : _vm._e(),
                              _vm.file.transportePuertoPais &&
                              _vm.isUseExternalForm
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "description",
                                      title:
                                        _vm.file.transportePuertoPais || "-",
                                      subtitle: "SubProceso"
                                    }
                                  })
                                : _vm._e(),
                              _vm.detailsFile.observaciones &&
                              _vm.detailsFile.observaciones.length === 2 &&
                              !_vm.isAguasAndinas
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "subject",
                                      title: _vm.getObservation(
                                        _vm.detailsFile.observaciones
                                      ),
                                      subtitle: "Observación"
                                    }
                                  })
                                : _vm._e(),
                              _vm.detailsFile.observaciones &&
                              _vm.detailsFile.observaciones.length === 2 &&
                              _vm.isAguasAndinas
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "subject",
                                      subtitle: "Observación"
                                    }
                                  })
                                : _vm._e(),
                              _vm.detailsFile.observaciones &&
                              _vm.detailsFile.observaciones.length === 2 &&
                              _vm.isAguasAndinas
                                ? _c("div", { staticClass: "scrollMateria" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getObservation(
                                            _vm.detailsFile.observaciones
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              _vm.detailsFile.observaciones &&
                              _vm.detailsFile.observaciones.length >= 1 &&
                              !_vm.isAguasAndinas
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "subject",
                                      title: _vm.getMatter(
                                        _vm.detailsFile.observaciones
                                      ),
                                      subtitle: "Materia"
                                    }
                                  })
                                : _vm._e(),
                              _vm.detailsFile.observaciones &&
                              _vm.detailsFile.observaciones.length >= 1 &&
                              _vm.isAguasAndinas
                                ? _c("vs-list-item", {
                                    attrs: {
                                      icon: "subject",
                                      subtitle: "Materia"
                                    }
                                  })
                                : _vm._e(),
                              _vm.detailsFile.observaciones &&
                              _vm.detailsFile.observaciones.length >= 1 &&
                              _vm.isAguasAndinas
                                ? _c("div", { staticClass: "scrollMateria" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getMatter(
                                            _vm.detailsFile.observaciones
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                : _vm._e(),
                              !_vm.isUseExternalForm
                                ? _c(
                                    "div",
                                    { staticClass: "mt-3" },
                                    [
                                      _c("h5", [_vm._v("Etiquetas")]),
                                      _vm._l(
                                        _vm.detailsFile.etiquetas,
                                        function(tag) {
                                          return _c(
                                            "div",
                                            { key: tag.dnt_etiqueta_id },
                                            [
                                              _c("vs-chip", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(tag.etiqueta) +
                                                    " "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        }
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.file.emisorInfoAdicional
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "shadow col-12" },
                      [
                        _c("vs-list", [
                          _c("div", { staticClass: "vs-list--item" }, [
                            _c("div", { staticClass: "vs-list--icon" }, [
                              _c(
                                "i",
                                {
                                  staticClass:
                                    "vs-icon notranslate icon-scale material-icons"
                                },
                                [_vm._v(" description ")]
                              )
                            ]),
                            _c("div", { staticClass: "list-titles" }, [
                              _c("div", { staticClass: "vs-list--title" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.file.emisorInfoAdicional,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.file.emisorInfoAdicional) +
                                        " "
                                    )
                                  ]
                                )
                              ]),
                              _c("div", { staticClass: "vs-list--subtitle" }, [
                                _vm._v(" URL Carpeta compartida ")
                              ])
                            ])
                          ])
                        ])
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          ),
          !_vm.loadingDocs && _vm.isConvention
            ? _c(
                "div",
                {
                  staticClass: "col-md-12 mt-5 shadow",
                  staticStyle: { margin: "0 auto" }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6 mt-5" }, [
                      _c("h5", [_vm._v(" Metadata ")]),
                      _vm.getTitleMetadata
                        ? _c("div", [
                            _c("b", [_vm._v("Título")]),
                            _c("div", [
                              _vm._v(" " + _vm._s(_vm.getTitleMetadata) + " ")
                            ])
                          ])
                        : _vm._e(),
                      _vm.getAlternativeTitleMetadata
                        ? _c("div", [
                            _c("b", [_vm._v("Título alternativo")]),
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getAlternativeTitleMetadata) +
                                  " "
                              )
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "col-6 mt-5" }, [
                      _c("h5", [_vm._v(" Metadata ")]),
                      _vm.getKeyboardsMetadata &&
                      _vm.getKeyboardsMetadata.length
                        ? _c(
                            "div",
                            [
                              _c("b", [_vm._v("Palabras Clave")]),
                              _vm._l(_vm.getKeyboardsMetadata, function(
                                keyword
                              ) {
                                return _c("div", { key: keyword.id }, [
                                  _vm._v(" - " + _vm._s(keyword.label) + " ")
                                ])
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _c("vs-divider"),
          _vm.loadingDocs
            ? _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "row px-5" },
                  [
                    _c("h5", { staticClass: "mb-0 ml-5" }, [
                      _vm._v("Adjuntar archivos:")
                    ]),
                    _c("load-files-new", {
                      ref: "attachedFiles",
                      staticClass: "col-12",
                      attrs: { values: _vm.attachments || [], withTrueCopy: "" }
                    }),
                    _vm.error.isPdf
                      ? _c("small", { staticClass: "text-danger ml-5 pl-5" }, [
                          _vm._v(_vm._s(_vm.error.isPdf))
                        ])
                      : _vm._e(),
                    _vm.error.noMainFile
                      ? _c("small", { staticClass: "text-danger ml-5 pl-5" }, [
                          _vm._v(_vm._s(_vm.error.noMainFile))
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col-12 mt-5 text-center" },
                      [
                        _c(
                          "vs-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "",
                                expression: "''"
                              }
                            ],
                            staticClass: "mr-2 btn btn-success",
                            attrs: { "data-cy": "save", disabled: _vm.loading },
                            on: { click: _vm.save }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.loading ? "Guardando..." : "Guardar"
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          !_vm.loadingDocs
            ? _c(
                "div",
                {
                  staticClass: "col-md-6 mt-5 shadow",
                  staticStyle: { margin: "0 auto" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "mt-5" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center justify-content-between"
                        },
                        [
                          _c("h5", { staticClass: "mb-0" }, [
                            _vm._v(" Destinos / Copias ")
                          ]),
                          _vm.hasInactiveSubjects
                            ? _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("small", { staticClass: "mr-2" }, [
                                    _vm._v("Ver inactivos")
                                  ]),
                                  _c("vs-switch", {
                                    attrs: {
                                      "data-cy": "toggle-inactive-subjects"
                                    },
                                    model: {
                                      value: _vm.showInactiveSubjects,
                                      callback: function($$v) {
                                        _vm.showInactiveSubjects = $$v
                                      },
                                      expression: "showInactiveSubjects"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      ),
                      _c(
                        "vs-table",
                        {
                          staticClass: "wrap-table-large mt-3",
                          attrs: {
                            stripe: "",
                            data: _vm.visibleSubjects || [],
                            noDataText: "No hay destinatarios"
                          }
                        },
                        [
                          _c("template", { slot: "header" }),
                          _c(
                            "template",
                            { slot: "thead" },
                            [
                              _c("vs-th", [_vm._v(" Nombre ")]),
                              _c("vs-th", [_vm._v(" Tipo ")]),
                              _c("vs-th", [_vm._v(" Alcance ")])
                            ],
                            1
                          ),
                          [
                            _c(
                              "tbody",
                              _vm._l(_vm.visibleSubjects, function(
                                subject,
                                index
                              ) {
                                return _c(
                                  "vs-tr",
                                  {
                                    key: index,
                                    class: {
                                      "subject-inactive": subject.estado == 2
                                    }
                                  },
                                  [
                                    _c(
                                      "vs-td",
                                      { attrs: { "data-cy": "suject" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(subject.destinoListaNombre) +
                                            " "
                                        ),
                                        _vm.externalSubject.includes(
                                          subject.destinoCodigo
                                        )
                                          ? _c(
                                              "small",
                                              {
                                                staticClass: "d-block",
                                                attrs: {
                                                  "data-cy": "subject-email"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      subject.destinoCorreo
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        subject.institucionNombre
                                          ? _c(
                                              "small",
                                              {
                                                staticClass: "d-block",
                                                attrs: {
                                                  "data-cy":
                                                    "subject-institution-name"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      subject.institucionNombre
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "small",
                                          { staticClass: "d-block" },
                                          [
                                            !_vm.externalSubject.includes(
                                              subject.destinoCodigo
                                            )
                                              ? _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      "data-cy": "subject-email"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          subject.destinoCorreo
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.internalSubject.includes(
                                              subject.destinoCodigo
                                            )
                                              ? _c(
                                                  "b-badge",
                                                  {
                                                    staticStyle: {
                                                      cursor: "pointer"
                                                    },
                                                    attrs: {
                                                      variant: "light-primary",
                                                      pill: "",
                                                      "data-cy":
                                                        "see-distribution"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.findEmails(
                                                          subject
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" ver distribución ")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "vs-td",
                                      { attrs: { "data-cy": "subject-type" } },
                                      [
                                        _vm.isAguasAndinas &&
                                        subject.destinoNombre === "Funcionarios"
                                          ? _c("span", [_vm._v(" Usuarios ")])
                                          : _vm._e(),
                                        _vm.isAguasAndinas &&
                                        subject.destinoNombre !== "Funcionarios"
                                          ? _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    subject.destinoNombre
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          : _vm._e(),
                                        !_vm.isAguasAndinas
                                          ? _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    subject.destinoNombre
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          : _vm._e(),
                                        subject.providenciaId
                                          ? _c(
                                              "small",
                                              { staticClass: "d-block" },
                                              [_c("b", [_vm._v("providencia")])]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _c(
                                      "vs-td",
                                      { staticClass: "text-center" },
                                      [
                                        _c(
                                          "div",
                                          [
                                            subject.tipoDestino === "1"
                                              ? _c(
                                                  "b-badge",
                                                  {
                                                    attrs: {
                                                      variant: "primary"
                                                    }
                                                  },
                                                  [_vm._v(" Destinatario ")]
                                                )
                                              : _vm._e(),
                                            subject.tipoDestino === "2"
                                              ? _c(
                                                  "b-badge",
                                                  {
                                                    attrs: { variant: "info" }
                                                  },
                                                  [_vm._v(" En copia ")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        subject.providenciaId
                                          ? _c(
                                              "div",
                                              { staticClass: "d-block" },
                                              [
                                                _c("small", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.providencesMap[
                                                          subject.providenciaId
                                                        ]
                                                      ) +
                                                      " "
                                                  ),
                                                  subject.providenciaVencimiento
                                                    ? _c("b", [
                                                        _vm._v(
                                                          " - " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "dateFormat"
                                                              )(
                                                                subject.providenciaVencimiento
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ])
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  !_vm.loadingDocs
                    ? _c(
                        "div",
                        { staticClass: " mt-5 mb-5" },
                        [
                          _c("h5", [_vm._v(" Comentarios ")]),
                          _c(
                            "vs-table",
                            {
                              staticClass: "wrap-table",
                              attrs: {
                                stripe: "",
                                data: _vm.orderCommentsEd || [],
                                noDataText: "No hay comentarios"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var data = ref.data
                                      return _vm._l(data, function(
                                        tr,
                                        indextr
                                      ) {
                                        return _c(
                                          "vs-tr",
                                          { key: indextr },
                                          [
                                            _c("vs-td", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    data[indextr]
                                                      .usuarioComentario
                                                  ) +
                                                  " "
                                              )
                                            ]),
                                            _c("vs-td", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("dateFormatTime")(
                                                      data[indextr]
                                                        .fechaCreacion
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]),
                                            _c("vs-td", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    data[indextr].comentario
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      })
                                    }
                                  }
                                ],
                                null,
                                false,
                                812957995
                              )
                            },
                            [
                              _c(
                                "template",
                                { slot: "thead" },
                                [
                                  _c("vs-th", [_vm._v(" Nombre ")]),
                                  _c("vs-th", [_vm._v(" Fecha ")]),
                                  _c("vs-th", [_vm._v(" Comentario ")])
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          !_vm.loadingDocs
            ? _c(
                "div",
                {
                  staticClass: "col-md-6 mt-5 shadow",
                  staticStyle: { margin: "0 auto" }
                },
                [
                  _c(
                    "div",
                    { staticClass: " mt-5" },
                    [
                      _c("h5", [_vm._v(" Archivos adjuntos ")]),
                      _c(
                        "vs-table",
                        {
                          attrs: {
                            stripe: "",
                            data: _vm.detailsFile.adjuntos || [],
                            noDataText: "No hay archivos adjuntos"
                          }
                        },
                        [
                          _c("template", { slot: "header" }),
                          _c(
                            "template",
                            { slot: "thead" },
                            [
                              _vm.isConvention
                                ? _c("vs-th", [_vm._v(" Nombre documento ")])
                                : _vm._e(),
                              _c("vs-th", [_vm._v(" Nombre Adjunto ")]),
                              _c("vs-th", [_vm._v(" Tipo ")]),
                              _c("vs-th", [_vm._v(" Formato ")]),
                              _c("vs-th", [_vm._v(" Ver ")])
                            ],
                            1
                          ),
                          [
                            _c(
                              "tbody",
                              _vm._l(_vm.attachments, function(attachment) {
                                return _c(
                                  "vs-tr",
                                  { key: attachment.adjuntoId },
                                  [
                                    _vm.isConvention
                                      ? _c("vs-td", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                attachment.tipoDescripcion
                                              ) +
                                              " "
                                          )
                                        ])
                                      : _vm._e(),
                                    _c("vs-td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(attachment.adjuntoNombre) +
                                          " "
                                      )
                                    ]),
                                    _c("vs-td", [
                                      _vm._v(
                                        " " + _vm._s(attachment.tipo) + " "
                                      )
                                    ]),
                                    _c("vs-td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(attachment.otraReferenciaId) +
                                          " "
                                      )
                                    ]),
                                    _c(
                                      "vs-td",
                                      [
                                        attachment &&
                                        attachment.adjuntoNombre &&
                                        attachment.adjuntoUrl
                                          ? _c("DownloadFile", {
                                              staticClass: "pill-info-attach",
                                              attrs: {
                                                mood: "compact",
                                                path: attachment.adjuntoUrl,
                                                name: attachment.adjuntoNombre
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  !_vm.loadingDocs
                    ? _c(
                        "div",
                        { staticClass: " mt-5 mb-5" },
                        [
                          _c("h5", [_vm._v(" Referencias ")]),
                          _c(
                            "vs-table",
                            {
                              staticClass: "wrap-table",
                              attrs: {
                                stripe: "",
                                data: _vm.detailsFile.referencias || [],
                                noDataText:
                                  "No hay otros documentos relacionados"
                              }
                            },
                            [
                              _c("template", { slot: "header" }),
                              _c(
                                "template",
                                { slot: "thead" },
                                [
                                  _c("vs-th", [_vm._v(" Tipo Documento ")]),
                                  _c("vs-th", [_vm._v(" Número ")])
                                ],
                                1
                              ),
                              [
                                !_vm.isUseExternalForm
                                  ? _c(
                                      "tbody",
                                      [
                                        _vm.file.transportePuertoCodigo &&
                                        !_vm.isUseExternalForm
                                          ? _c(
                                              "vs-tr",
                                              [
                                                _c("vs-td", [
                                                  _vm._v(" Contrato SAFI ")
                                                ]),
                                                _c("vs-td", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.file
                                                          .transportePuertoCodigo
                                                      ) +
                                                      " "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._l(
                                          _vm.detailsFile.referencias || [],
                                          function(reference) {
                                            return _c(
                                              "vs-tr",
                                              {
                                                key: reference.dntReferenciaId
                                              },
                                              [
                                                _c("vs-td", [
                                                  reference.documentoId
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.findTypeDocument(
                                                                reference.tipoDocumento
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  !reference.documentoId
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.findLabelDocument(
                                                                reference.tipoDocumento
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]),
                                                _c("vs-td", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(reference.folio) +
                                                      " "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm.isUseExternalForm
                                  ? _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.detailsFile.referencias || [],
                                        function(reference) {
                                          return _c(
                                            "vs-tr",
                                            { key: reference.dntReferenciaId },
                                            [
                                              _c("vs-td", [
                                                reference.documentoId
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.findTypeDocument(
                                                              reference.tipoDocumento
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                !reference.documentoId
                                                  ? _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.findLabelDocument(
                                                              reference.tipoDocumento
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ]),
                                              _c("vs-td", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(reference.folio) +
                                                    " "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e()
                              ]
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "emailsGroup",
          attrs: {
            id: "emailsGroup",
            title: "Distribución dentro del grupo",
            "hide-footer": ""
          }
        },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.loadingUsers } },
            [
              _vm.usersGroup.length
                ? _c(
                    "vs-list",
                    _vm._l(_vm.usersGroup, function(user) {
                      return _c("vs-list-item", {
                        key: user.id,
                        attrs: {
                          icon: "person",
                          title: user.nombre,
                          subtitle: user.correo
                        }
                      })
                    }),
                    1
                  )
                : _vm._e(),
              !_vm.usersGroup.length
                ? _c("div", [
                    _c("h5", [_vm._v("No hay usuarios para distribuir")])
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }